import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'
import { ReactElement } from 'react'

import { useAppSelector } from '../../store/hooks'

interface PolicyCheckProps {
  children: ReactElement
  policyName: string
  disablePolicyCheck?: boolean
  defaultComponent?: ReactElement
}

const PolicyCheckHOC = (props: PolicyCheckProps) => {
  const { children, policyName, disablePolicyCheck, defaultComponent } = props
  const policies = useAppSelector(selectPolicies)

  return (
    <>
      {disablePolicyCheck || policies.includes(policyName)
        ? children
        : defaultComponent || null}
    </>
  )
}

export default PolicyCheckHOC
